// Language switching functionality
export const translations = {
	en: {
		// Meta
		title: 'Nikita Karasyov | Frontend Developer',

		// Boot sequence
		bootLine1: '> Initializing portfolio system...',
		bootLine2: '> Loading developer profile...',
		bootLine3: '> Connecting to skills database...',
		bootLine4: '> [OK] System ready',
		bootLine5: "> Welcome to Nikita Karasyov's portfolio",

		// About section
		aboutAge: '> Frontend Developer | 4+ years experience',
		aboutBorn: '> Age: 22 | Born: January 29, 2003',
		aboutLocation: '> Location: All world',
		aboutStatus: '> Status: Available for new opportunities',
		aboutSpec: '> Specialization: React, Vue.js, TypeScript, Next.js',
		aboutQuote:
			'> "Create adaptive user interfaces with clean and scalable code"',

		// Experience
		jobLuminary: 'Frontend Developer',
		jobLuminaryDesc1:
			'> B2B web application development with React & TypeScript',
		jobLuminaryDesc2: '> Created and maintained component library',
		jobLuminaryDesc3:
			'> Performance optimization and code quality improvements',
		jobLuminaryDesc4: '> Cross-functional team collaboration',

		jobEasycode: 'Frontend Developer',
		jobEasycodeDesc1: '> Corporate HR system development',
		jobEasycodeDesc2: '> Interactive dashboards with Vue.js',
		jobEasycodeDesc3: '> Built responsive interfaces from Figma designs',
		jobEasycodeDesc4: '> Mentored junior developers and code reviews',

		jobBottec: 'Frontend Developer',
		jobBottecDesc1: '> Led development of 11 projects from scratch',
		jobBottecDesc2: '> Team leadership and project coordination',
		jobBottecDesc3: '> Full-stack development with modern technologies',
		jobBottecDesc4: '> 100% projects successfully delivered to production',

		// Education
		eduMfpu: 'Higher Education',
		eduMfpuDesc:
			'> Specialized in information technologies and business processes',
		eduHexlet: 'Frontend Development Course',
		eduHexletDesc1: '> Intensive web development program',
		eduHexletDesc2: '> JavaScript, React, modern development practices',
		eduSelf: 'Continuous Learning',
		eduSelfDesc1: '> Various online courses in web development',
		eduSelfDesc2: '> Cybersecurity and system administration',
		eduSelfDesc3: '> UX/UI Design and modern web technologies',

		// Achievements
		achProjects: 'Completed Projects',
		achProduction: 'Projects in Production',
		achTeam: 'Team Members Led',
		achExperience: 'Years Experience',

		// Contact
		email: '> email:',
		telegram: '> telegram:',
		github: '> github:',
		linkedin: '> linkedin:',
		phoneRu: '> phone_ru:',
		phoneVn: '> phone_vn:',
		privacy: '> privacy:',
		privacyText: 'privacy policy',

		// Commands
		langSwitch: 'lang --switch',
		langSwitchDesc: 'Switch language between English and Russian',
		contactDesc: 'Start contact',
	},
	ru: {
		// Meta
		title: 'Никита Карасёв | Frontend разработчик',

		// Boot sequence
		bootLine1: '> Инициализация системы портфолио...',
		bootLine2: '> Загрузка профиля разработчика...',
		bootLine3: '> Подключение к базе навыков...',
		bootLine4: '> [ОК] Система готова',
		bootLine5: '> Добро пожаловать в портфолио Никиты Карасёва',

		// About section
		aboutAge: '> Frontend разработчик | 4+ года опыта',
		aboutBorn: '> Возраст: 22 | Родился: 29 января 2003',
		aboutLocation: '> Локация: Весь мир',
		aboutStatus: '> Статус: Открыт к новым возможностям',
		aboutSpec: '> Специализация: React, Vue.js, TypeScript, Next.js',
		aboutQuote:
			'> "Создаю адаптивные пользовательские интерфейсы с чистым и масштабируемым кодом"',

		// Experience
		jobLuminary: 'Frontend разработчик',
		jobLuminaryDesc1:
			'> Разработка B2B веб-приложений на React и TypeScript',
		jobLuminaryDesc2: '> Создание и поддержка библиотеки компонентов',
		jobLuminaryDesc3: '> Оптимизация производительности и качества кода',
		jobLuminaryDesc4: '> Сотрудничество в кроссфункциональной команде',

		jobEasycode: 'Frontend разработчик',
		jobEasycodeDesc1: '> Разработка корпоративной HR системы',
		jobEasycodeDesc2: '> Интерактивные дашборды на Vue.js',
		jobEasycodeDesc3: '> Создание адаптивных интерфейсов по дизайну Figma',
		jobEasycodeDesc4: '> Менторство младших разработчиков и код-ревью',

		jobBottec: 'Frontend разработчик',
		jobBottecDesc1: '> Руководил разработкой 11 проектов с нуля',
		jobBottecDesc2: '> Лидерство команды и координация проектов',
		jobBottecDesc3: '> Fullstack разработка с современными технологиями',
		jobBottecDesc4: '> 100% проектов успешно запущены в продакшн',

		// Education
		eduMfpu: 'Высшее образование',
		eduMfpuDesc:
			'> Специализация в области информационных технологий и бизнес-процессов',
		eduHexlet: 'Курс Frontend разработки',
		eduHexletDesc1: '> Интенсивная программа веб-разработки',
		eduHexletDesc2: '> JavaScript, React, современные практики разработки',
		eduSelf: 'Непрерывное обучение',
		eduSelfDesc1: '> Различные онлайн-курсы по веб-разработке',
		eduSelfDesc2: '> Кибербезопасность и системное администрирование',
		eduSelfDesc3: '> UX/UI дизайн и современные веб-технологии',

		// Achievements
		achProjects: 'Завершенных проектов',
		achProduction: 'Проектов в продакшне',
		achTeam: 'Участников команды',
		achExperience: 'Лет опыта',

		// Contact
		email: '> почта:',
		telegram: '> телеграм:',
		github: '> гитхаб:',
		linkedin: '> линкедин:',
		phoneRu: '> телефон_рф:',
		phoneVn: '> телефон_вн:',
		privacy: '> privacy:',
		privacyText: 'политика конфиденциальности',

		// Commands
		langSwitch: 'lang --switch',
		langSwitchDesc: 'Переключить язык между английским и русским',
		contactDesc: 'Запустить форму контакта для связи',
	},
};

function detectLanguage() {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('lang') === 'en') {
		return 'en';
	}
	return 'ru';
}

export let currentLanguage = detectLanguage();

export function switchLanguage() {
	currentLanguage = currentLanguage === 'en' ? 'ru' : 'en';

	// Update page title
	document.title = translations[currentLanguage].title;

	// Update all translatable elements
	updateTranslations();

	// Trigger SEO meta updates
	window.dispatchEvent(new CustomEvent('languageChanged', {
		detail: { language: currentLanguage }
	}));

	// Update URL without reload
	const url = new URL(window.location);
	if (currentLanguage === 'en') {
		url.searchParams.set('lang', 'en');
	} else {
		url.searchParams.delete('lang');
	}
	window.history.pushState({}, '', url);

	// Show success message
	const terminalContent = document.querySelector('.terminal-content');
	const successDiv = document.createElement('div');
	successDiv.style.cssText = `
        color: var(--neon-green);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
	successDiv.textContent = `Language switched to ${
		currentLanguage === 'en' ? 'English' : 'Русский'
	}`;

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(successDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(successDiv);
	}
}

export function updateTranslations() {
	const t = translations[currentLanguage];

	// Boot sequence
	const bootLines = document.querySelectorAll('.boot-sequence .line');
	bootLines[0].textContent = t.bootLine1;
	bootLines[1].textContent = t.bootLine2;
	bootLines[2].textContent = t.bootLine3;
	bootLines[3].textContent = t.bootLine4;
	bootLines[4].textContent = t.bootLine5;

	// About section
	const aboutContent = document.querySelector('.info-block .content');
	if (aboutContent) {
		const paragraphs = aboutContent.querySelectorAll('p');
		paragraphs[0].textContent = t.aboutAge;
		paragraphs[1].textContent = t.aboutBorn;
		paragraphs[2].textContent = t.aboutLocation;
		paragraphs[3].textContent = t.aboutStatus;
		paragraphs[4].textContent = t.aboutSpec;
		paragraphs[5].textContent = t.aboutQuote;
	}

	// Experience section
	const jobs = document.querySelectorAll('.job');

	// Luminary
	if (jobs[0]) {
		jobs[0].querySelector('.position').textContent = t.jobLuminary;
		const luminaryDesc = jobs[0].querySelectorAll('.job-description p');
		luminaryDesc[0].textContent = t.jobLuminaryDesc1;
		luminaryDesc[1].textContent = t.jobLuminaryDesc2;
		luminaryDesc[2].textContent = t.jobLuminaryDesc3;
		luminaryDesc[3].textContent = t.jobLuminaryDesc4;
	}

	// EasyCode
	if (jobs[1]) {
		jobs[1].querySelector('.position').textContent = t.jobEasycode;
		const easycodeDesc = jobs[1].querySelectorAll('.job-description p');
		easycodeDesc[0].textContent = t.jobEasycodeDesc1;
		easycodeDesc[1].textContent = t.jobEasycodeDesc2;
		easycodeDesc[2].textContent = t.jobEasycodeDesc3;
		easycodeDesc[3].textContent = t.jobEasycodeDesc4;
	}

	// BOTTEC
	if (jobs[2]) {
		jobs[2].querySelector('.position').textContent = t.jobBottec;
		const bottecDesc = jobs[2].querySelectorAll('.job-description p');
		bottecDesc[0].textContent = t.jobBottecDesc1;
		bottecDesc[1].textContent = t.jobBottecDesc2;
		bottecDesc[2].textContent = t.jobBottecDesc3;
		bottecDesc[3].textContent = t.jobBottecDesc4;
	}

	// Education section
	const educationItems = document.querySelectorAll('.education-item');

	if (educationItems[0]) {
		educationItems[0].querySelector('.degree').textContent = t.eduMfpu;
		educationItems[0].querySelector('.edu-description p').textContent =
			t.eduMfpuDesc;
	}

	if (educationItems[1]) {
		educationItems[1].querySelector('.degree').textContent = t.eduHexlet;
		const hexletDesc =
			educationItems[1].querySelectorAll('.edu-description p');
		hexletDesc[0].textContent = t.eduHexletDesc1;
		hexletDesc[1].textContent = t.eduHexletDesc2;
	}

	if (educationItems[2]) {
		educationItems[2].querySelector('.degree').textContent = t.eduSelf;
		const selfDesc =
			educationItems[2].querySelectorAll('.edu-description p');
		selfDesc[0].textContent = t.eduSelfDesc1;
		selfDesc[1].textContent = t.eduSelfDesc2;
		selfDesc[2].textContent = t.eduSelfDesc3;
	}

	// Achievements
	const achievements = document.querySelectorAll(
		'.achievement-item .description'
	);
	achievements[0].textContent = t.achProjects;
	achievements[1].textContent = t.achProduction;
	achievements[2].textContent = t.achTeam;
	achievements[3].textContent = t.achExperience;

	// Contact section
	const contactItems = document.querySelectorAll('.contact-item .label');
	contactItems[0].textContent = t.email;
	contactItems[1].textContent = t.telegram;
	contactItems[2].textContent = t.github;
	contactItems[3].textContent = t.linkedin;
	contactItems[4].textContent = t.phoneRu;
	contactItems[5].textContent = t.phoneVn;
	if (contactItems[6]) {
		contactItems[6].textContent = t.privacy;
	}
}
